import { render, staticRenderFns } from "./module7.vue?vue&type=template&id=842f4ff0&scoped=true"
import script from "./module7.vue?vue&type=script&lang=js"
export * from "./module7.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842f4ff0",
  null
  
)

export default component.exports